import React from 'react';
// -*- mode: jsx;-*-
/* eslint-disable react/prop-types */

import { FavoriteHeart } from '../common/favoriteHeart.js';
import usePrimarySearchData from './usePrimarySearchData.js';

let FavoriteSearch = ({ favorites, searchURL, projects, callbacks }) => {
    const { searchVOHashCode } = usePrimarySearchData(projects);

    // This function won't exist on the server side
    /* global isSearchAFavorite */
    const isFavorite = typeof isSearchAFavorite === 'function' &&
        // This method already checks for school ID when determining whether it's a favorite
        isSearchAFavorite(searchURL, searchVOHashCode, favorites.searchHashes, favorites.schoolIds);

    // When linking to the search page from the saved searches section of the homepage,
    // we append newSince to only show the donor projects we haven't seen yet.
    // We still want this to be treated as the same saved search,
    // so we strip off the trailing newSince here.
    const favoriteURL = searchURL.replace(/&newSince=\d+$/, '');

    // Our server-side FavoriteSearchService.addSearchMMI method will create a school follow
    // instead of a saved search if the school param is present. We update the display text
    // here to reflect that.
    let activeText, inactiveText, buttonText;
    /* global Uri */
    if (new Uri(searchURL).hasQueryParam('school')) {
        activeText = 'Followed!';
        inactiveText = 'Follow school';
        buttonText = 'Follow this school!';
    } else {
        activeText = 'Saved!';
        inactiveText = 'Save search';
        buttonText = 'Save this search';
    }

    return <FavoriteHeart favoriteType="searchURL" favoriteValue={favoriteURL}
        loadFavorites={callbacks.loadFavorites}
        isFavorite={isFavorite} trackingName="Follow-search" pageURL={searchURL}
        activeText={activeText} inactiveText={inactiveText}
        formDivClassName="followEmailHolder subnav save-search-popup"
        buttonText={buttonText} />;
};

FavoriteSearch = React.memo(FavoriteSearch);
export default FavoriteSearch;
